/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-19 17:22:39
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-18 17:31:04
 */
import React, { useEffect, useState } from 'react'
import { Badge, Button, notification, Popover, TableColumnType } from 'antd'
import { EditableColumnType } from '../../compnents/list/EditableList'
import moment from 'moment'
import { ItemCompletionType } from '../completion/completionSlice'
import './notshow.css'
import { DateTimeFormatSimple } from '../../models/datetime'
import { selectTenantCategory, selectTenantName } from '../../app/applicationSlice'
import { useSelector } from 'react-redux'
import styles from './Putstorelist.module.css'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'

// 从按钮所在 <tr> 获取当前行发票号输入框的实时值
// 用 closest('tr') 保证只查找当前按钮所在的行（与发票号输入框同在一个右固定表 <tr> 中）
const getLiveInvoiceNb = (e: React.MouseEvent<HTMLElement>): string | undefined => {
    try {
        const tr = (e.currentTarget as HTMLElement).closest('tr')
        if (tr) {
            const input = tr.querySelector<HTMLInputElement>('input[placeholder="发票号码"]')
            if (input) return input.value || undefined
        }
    } catch (e) {
        // ignore
    }
    return undefined
}

// 从按钮所在 <tr> 获取当前行批次号输入框的实时值
// 批次号是必填项，清空后点击保存应被校验拦截，因此这里不能用 || 兜底（否则会读到记录里已提交的旧批次号）
const getLiveBatchNo = (e: React.MouseEvent<HTMLElement>): string | undefined => {
    try {
        const tr = (e.currentTarget as HTMLElement).closest('tr')
        if (tr) {
            const input = tr.querySelector<HTMLInputElement>('input[placeholder=" 批次号"]')
            if (input) return input.value
        }
    } catch (e) {
        // ignore
    }
    return undefined
}

export const PurchaseStockColumns = (
  //购入入库
  storehouseTag: number,
  ybUploadFlag: number,
  onclick: (text: string, t: any, flag?: any) => void,
  storehouseCategory?: any,
  noScrollFlag?:any,
  categoryTag?: any,
  dataList?: any[],
  KFGZZCKLRSJData?: any,
  invoiceEntryEnabled?: boolean,
  receiptsType?: number,
): EditableColumnType<any>[] => {
  const [oneNexIndex, setOneNexIndex] = useState<any>()
  const [nexIndexCount, setNexIndexCount] = useState<any>()
  const tenantCategory = useSelector(selectTenantCategory)
  const settings = useSelector(selectSettings)

  //  const productDateFlag = requiredList?.filter(
  //   (v: any) => v?.name == '生产日期'
  // )?.length ? true :false

  // 新老目录展示方式
  const getProcuctInfo = (item: any) => {
    const materialsCategory = item.materialsCategory
    const packSpec = item.packSpec ? item.packSpec : '-'
    const doseCategory = item.doseCategory ? item.doseCategory : '-'
    const tenantSupplierName = item.tenantSupplierName ? item.tenantSupplierName : '-'
    const model = item.model ? item.model + '/' : ''
    const accountUnit = item.accountUnit ? item.accountUnit : '-'
    const spec = item.spec ? item.spec : '-'

    if (settings?.[Checks.MLKG] == 1) {
      if (materialsCategory == '0') {
        // 包装规格 + 剂型 + 生产厂家
        return packSpec + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 包装规格 + 型号 + 生产厂家
        return  packSpec + '/' + model + tenantSupplierName
      } else {
        // 包装规格 + 生产厂家
        return packSpec + '/' + tenantSupplierName
      }
    } else {
      if (materialsCategory == '0') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 剂型 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + doseCategory + '/' + tenantSupplierName
      } else if (materialsCategory == '1' || materialsCategory == '2') {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 型号 + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + model + tenantSupplierName
      } else {
        // 规格 + 包装规格 + 包装单位（账簿单位） + 生产厂家
        return spec + '/' + packSpec + '/' + accountUnit + '/' + tenantSupplierName
      }
    }
  }
  const columns: EditableColumnType<any>[] =[
    {
      title: '操作',
      align: 'center',
      fixed: 'left',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      fixed: 'left',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    // 0512通用名修改 名称->通用名
    {
      title: '通用名',
      align: 'center',
      inputType: 'material',
      dataIndex: 'name',
      width: '190px',
      ellipsis: true,
      key: 'name',
      receiptsType: receiptsType,
      // nextDataIndex: 'productDate',
      nextDataIndex: invoiceEntryEnabled !== false ? 'invoiceNb' : 'productDate',
      fixed: 'left',
      placeholder: '药品名称/助记码/条形码',
      categoryTag: categoryTag,
      storehouseCategory: storehouseCategory,
      editable: storehouseTag > 0 ? false : true,
      autoFocus: (r) => noScrollFlag ? false : !r.id && !r.name,
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata:any) => {
        const tenantMaterialsCatalogId = newdata.id
        const unitPrice =  newdata?.backFillStockPrice > 0 ? newdata.backFillStockPrice : 0
        const retailPrice = newdata?.backFillRetailPrice > 0 ? newdata.backFillRetailPrice : 0
        const splitPrice = newdata?.backFillSplitPrice > 0 ? newdata.backFillSplitPrice : 0
        const next = {
          ...newdata,
          unitPrice,
          retailPrice,
          splitPrice,
          tenantMaterialsCatalogId,
          id: undefined,
        }
        onclick('edit', { prev, next })
        setOneNexIndex(prev?.id ? (null as any) : 'retailPrice')
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        // onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      key: 'genericName',
      width: '190px',
      ellipsis: true,
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      key: 'productInfo',
      width: '450px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.productInfo) {
          return t.productInfo
        } else {
          getProcuctInfo(t)
        }
      },
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '160px',
      ellipsis: true,
    },
    {
      title: '医保国码',
      align: 'center',
      dataIndex: 'hilistCode',
      key: 'hilistCode',
      width: '160px',
      ellipsis: true,
    },
    {
      title: '批准文号',
      align: 'center',
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
      width: '120px',
      ellipsis: true,
    },
    {
      title: '柜号',
      align: 'right',
      width: '50px',
      ellipsis: true,
      editable: false,
      dataIndex: 'cabineNo',
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '发票号',
      align: 'center',
      width: '130px',
      ellipsis: true,
      editable: true,
      invoiceNbSynchronization: true,
      dataIndex: 'invoiceNb',
      dataList: dataList,
      inputType: 'invoiceNb',
      nextDataIndex: 'productDate',
      storehouseTag: storehouseTag,
      // nextDataIndex: 'invoiceNb',
      placeholder: '发票号码',
      fixed: 'right',
      onSave: (prev, next, flag) => {
        // flag 发票号同步
        if (flag) {
          // 登账后
          onclick(prev.id ? 'submit' : 'edit', { prev, next }, 'invoiceNbSynchronizationFlag')
        }else{
          // 直接点击
          onclick(prev.id ? 'submit' : 'edit', { prev, next }, 'invoiceNbFlag')
        }
      },
      render: function Element(_, t) {
        return t.invoiceNb ? <span title={t.invoiceNb}>{t.invoiceNb}</span> : ''
      },
    },
    {
      title: '生产日期',
      align: 'center',
      width: '6rem',
      ellipsis: true,
      key: 'productDate',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'productDate',
      nextDataIndex: 'deadline',
      placeholder: ' 20240818',
      fixed: 'right',
      // autoFocus: (r) => productDateFlag ,
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (productDate) => {
        return productDate &&
          productDate !== undefined &&
          productDate !== '' &&
          productDate !== 'Invalid date'
          ? moment(productDate).format(DateTimeFormatSimple)
          : undefined
      },
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '有效期',
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'deadline',
      width: '6rem',
      ellipsis: true,
      nextDataIndex: 'batchNo',
      placeholder: ' 20290818',
      // autoFocus: (r) => deadlineFlag,
      fixed: 'right',
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline &&
          deadline !== undefined &&
          deadline !== '' &&
          deadline !== 'Invalid date'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '批号',
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'batchNo',
      width: '110px',
      ellipsis: true,
      nextDataIndex: 'unitPrice',
      fixed: 'right',
      placeholder: ' 批次号',
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '入库单价',
      align: 'right',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'unitPrice',
      width: '5.5rem',
      ellipsis: true,
      nextDataIndex: oneNexIndex,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: [
        // {
        //   required: true,
        //   message: '请输入入库单价',
        // },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        setOneNexIndex(null as any)
        setOneNexIndex(prev?.id ? (null as any) : 'retailPrice')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const hasUnitPrice = t.unitPrice !== '' && t.unitPrice != null
        const displayValue = hasUnitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
        return storehouseTag > 0 && !KFGZZCKLRSJData ? '***': (hasUnitPrice ? (
          <span
            title={displayValue}
            onClick={(v) => {
              setOneNexIndex(null as any)
              setOneNexIndex(t?.id ? (null as any) : 'retailPrice')
            }}
          >
            {displayValue}{' '}
          </span>
        ) : (
          ''
        ))
      },
    },
    {
      title: '零售单价',
      align: 'right',
      width: '5.5rem',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'retailPrice',
      nextDataIndex: nexIndexCount,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: [
        {
          required: true,
          message: '请输入零售单价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        setNexIndexCount(null as any)
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const displayValue = t.retailPrice && t.retailPrice > 0 ? parseFloat(t.retailPrice).toFixed(5) : ''
        return t.retailPrice && t.retailPrice > 0 ? (
          <span
            title={displayValue}
            onClick={(v) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {displayValue}{' '}
          </span>
        ) : (
          ''
        )
      },
    },
    {
      title: '拆零单价',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'splitPrice',
      nextDataIndex: nexIndexCount,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: (record: any) => record.tenantInventoryLedgerId ? [] : [
        {
          required: true,
          message: '请输入拆零单价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        setNexIndexCount(null as any)
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const displayValue = t.splitPrice ? parseFloat(t.splitPrice).toFixed(5) : ''
        return t.splitTag?.toString() == '1' && t.splitPrice > 0 ? (
          <span
            title={displayValue}
            onClick={(v: any) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {t.splitPrice ? parseFloat(t.splitPrice).toFixed(5) : ''}
          </span>
        ) : t.splitTag?.toString() == '0' && t.splitPrice > 0 ? (
          <span
            title='0.00000'
            onClick={(v: any) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {t.splitPrice ? parseFloat('0').toFixed(5) : '0.00000'}
          </span>
        ) : (
          <span title={t.splitPrice ? String(t.splitPrice) : ''}>{t.splitPrice ? t.splitPrice : ''}</span>
        )
      },
    },
    {
      title: '数量',
      align: 'right',
      width: '60px',
      ellipsis: true,
      fixed: 'right',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'count',
      placeholder: ' 1.00',
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '小计',
      align: 'right',
      width: '80px',
      ellipsis: true,
      fixed: 'right',
      dataIndex: 'totalPrice',
      render: (_, t) => {
        return storehouseTag > 0 && !KFGZZCKLRSJData ? '***' : t.totalPrice ? parseFloat(t.totalPrice).toFixed(2) : ''
      },
    },
     {
      title: '追溯码',
      align: 'center',
      fixed: 'right',
      width: '106px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div className={styles.bradeContent}>
            {(t?.billingCategory == '01' ||
              t?.billingCategory == '02' ||
              t?.billingCategory == '17') &&
              t.tenantInventoryLedgerId &&
              t?.name ? (
              <Button
                ghost
                type='primary'
                onClick={() => {
                  onclick('code', t)
                }}
                // style={{ color: t?.traceCodeCount < 0  ? '#999999' : '#027AFF' }}
              >
                {t?.traceCodeCount < 0 ? '未采集' : '已采' + (t?.traceCodeCount < 0 ? 0 : t?.traceCodeCount)}
              </Button>

            ) : (
              <></>
            )}
          </div>
        )
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '80px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div className={styles.bradeContent}>
            {t?.tenantMaterialsCatalogId && (
                <Button
                    ghost
                    type={'primary'}
                    disabled={storehouseTag > 0 ? true : false}
                    size='middle'
                    onClick={(e) => {
                        const liveBatchNo = getLiveBatchNo(e)
                        onclick('save', {
                            ...t,
                            invoiceNb: getLiveInvoiceNb(e) || t.invoiceNb,
                            batchNo: liveBatchNo !== undefined ? liveBatchNo : t.batchNo,
                        })
                    }}
                >
                    保存
                </Button>
            )}
          </div>
        )
      },
    },
  ]
  return  invoiceEntryEnabled !== false
      ? tenantCategory == 17
      ? columns?.filter((v: any) => v?.dataIndex != 'hilistCode' && v?.dataIndex != 'retailPrice' && v?.dataIndex != 'splitPrice')
      : columns 
    : tenantCategory == 17 
      ? columns?.filter((v: any) => v?.dataIndex != 'invoiceNb' && v?.dataIndex != 'hilistCode' && v?.dataIndex != 'retailPrice' && v?.dataIndex != 'splitPrice')
      : columns?.filter((v: any) => v?.dataIndex != 'invoiceNb')
}

// 余姚白兔眼科诊所有限公司
export const PurchaseStockCFCPXXColumns = (
  //购入入库
  storehouseTag: number,
  ybUploadFlag: number,
  onclick: (text: string, t: any, flag?: any) => void,
  storehouseCategory?: any,
  noScrollFlag?: any,
  categoryTag?: any,
  dataList?: any[],
  KFGZZCKLRSJData?: any,
  invoiceEntryEnabled?: boolean,
  receiptsType?: number,
): EditableColumnType<any>[] => {
  const [oneNexIndex, setOneNexIndex] = useState<any>()
  const [nexIndexCount, setNexIndexCount] = useState<any>()
  //  const productDateFlag = requiredList?.filter(
  //   (v: any) => v?.name == '生产日期'
  // )?.length ? true :false

  // const deadlineFlag = requiredList?.filter((v: any) => v?.name == '有效期')

  const columns: EditableColumnType<any>[] = [
    {
      title: '操作',
      align: 'center',
      fixed: 'left',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      fixed: 'left',
      width: '40px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    // 0512通用名修改 名称->通用名
    {
      title: '通用名',
      align: 'center',
      inputType: 'material',
      dataIndex: 'name',
      width: '190px',
      ellipsis: true,
      key: 'name',
      receiptsType: receiptsType,
      // nextDataIndex: 'invoiceNb',
      nextDataIndex: invoiceEntryEnabled !== false ? 'invoiceNb' : 'productDate',
      placeholder: ' 药品名称/助记码/条形码',
      fixed: 'left',
      storehouseCategory: storehouseCategory,
      categoryTag: categoryTag,
      editable: storehouseTag > 0 ? false : true,
      autoFocus: (r) => noScrollFlag ? false : !r.id && !r.name,
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata:any) => {
        const tenantMaterialsCatalogId = newdata.id
        const unitPrice = newdata?.backFillStockPrice > 0 ? newdata.backFillStockPrice : 0
        const retailPrice =  newdata?.backFillRetailPrice > 0 ? newdata.backFillRetailPrice : 0
        const splitPrice = newdata?.backFillSplitPrice > 0 ? newdata.backFillSplitPrice : 0
        const next = {
          ...newdata,
          unitPrice,
          retailPrice,
          splitPrice,
          tenantMaterialsCatalogId,
          id: undefined,
        }
        onclick('edit', { prev, next })
        setOneNexIndex(prev?.id ? (null as any) : 'retailPrice')
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        // onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    // 0512通用名修改 通用名->商品名
    {
      title: '商品名',
      align: 'center',
      dataIndex: 'genericName',
      key: 'genericName',
      width: '190px',
      ellipsis: true,
    },
    {
      title: '规格',
      align: 'center',
      dataIndex: 'spec',
      key: 'spec',
      width: '170px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.spec) {
          return <>{t.spec}</>
        } else {
          return <></>
        }
      },
    },
    {
      title: '包装规格',
      align: 'center',
      dataIndex: 'packSpec',
      key: 'packSpec',
      width: '170px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.packSpec) {
          return <>{t.packSpec}</>
        } else {
          return <></>
        }
      },
    },
    {
      title: '单位',
      align: 'center',
      dataIndex: 'accountUnit',
      key: 'accountUnit',
      width: '100px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.accountUnit) {
          return <>{t.accountUnit}</>
        } else {
          return <></>
        }
      },
    },
    {
      title: '剂型',
      align: 'center',
      dataIndex: 'doseCategory',
      key: 'doseCategory',
      width: '100px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.doseCategory) {
          return <>{t.doseCategory}</>
        } else {
          return <></>
        }
      },
    },
    {
      title: '厂家',
      align: 'center',
      dataIndex: 'tenantSupplierName',
      key: 'tenantSupplierName',
      width: '170px',
      ellipsis: true,
      render: function Element(_, t) {
        if (t.tenantSupplierName) {
          return <>{t.tenantSupplierName}</>
        } else {
          return <></>
        }
      },
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '160px',
      ellipsis: true,
    },
    {
      title: '医保国码',
      align: 'center',
      dataIndex: 'hilistCode',
      key: 'hilistCode',
      width: '160px',
      ellipsis: true,
    },
    {
      title: '批准文号',
      align: 'center',
      dataIndex: 'approvalNumber',
      key: 'approvalNumber',
      width: '120px',
      ellipsis: true,
    },
    {
      title: '柜号',
      align: 'right',
      width: '50px',
      ellipsis: true,
      editable: false,
      dataIndex: 'cabineNo',
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '发票号',
      align: 'center',
      width: '130px',
      ellipsis: true,
      editable: true,
      invoiceNbSynchronization: true,
      dataIndex: 'invoiceNb',
      dataList: dataList,
      inputType: 'invoiceNb',
      storehouseTag: storehouseTag,
      // nextDataIndex: 'invoiceNb',
      nextDataIndex: 'productDate',
      placeholder: '发票号码',
      fixed: 'right',
      onSave: (prev, next, flag) => {
        // flag 发票号同步
        if (flag) {
          // 登账后
            onclick(prev.id ? 'submit' : 'edit', { prev, next }, 'invoiceNbSynchronizationFlag')
        }else{
          // 直接点击
            onclick(prev.id ? 'submit' : 'edit', { prev, next }, 'invoiceNbFlag')
        }
      },
      render: function Element(_, t) {
        return t.invoiceNb ? <span title={t.invoiceNb}>{t.invoiceNb}</span> : ''
      },
    },
    {
      title: '生产日期',
      align: 'center',
      width: '76px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'productDate',
      nextDataIndex: 'deadline',
      placeholder: ' 20240818',
      fixed: 'right',
      // autoFocus: (r) => productDateFlag ,
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (productDate) => {
        return productDate &&
          productDate !== undefined &&
          productDate !== '' &&
          productDate !== 'Invalid date'
          ? moment(productDate).format(DateTimeFormatSimple)
          : undefined
      },
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '有效期',
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'deadline',
      width: '76px',
      ellipsis: true,
      nextDataIndex: 'batchNo',
      placeholder: ' 20290818',
      // autoFocus: (r) => deadlineFlag,
      fixed: 'right',
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline &&
          deadline !== undefined &&
          deadline !== '' &&
          deadline !== 'Invalid date'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '批号',
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'batchNo',
      width: '110px',
      ellipsis: true,
      nextDataIndex: 'unitPrice',
      placeholder: ' 批次号',
      fixed: 'right',
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
        {
          max: 100,
          message: '最多100个字',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '入库单价',
      align: 'right',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'unitPrice',
      width: '68px',
      ellipsis: true,
      nextDataIndex: oneNexIndex,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: [
        // {
        //   required: true,
        //   message: '请输入入库单价',
        // },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        setOneNexIndex(null as any)
        setOneNexIndex(prev?.id ? (null as any) : 'retailPrice')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const hasUnitPrice = t.unitPrice !== '' && t.unitPrice != null
        const displayValue = hasUnitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
        return storehouseTag > 0 && !KFGZZCKLRSJData ? '***' : hasUnitPrice ? (
          <span
            title={displayValue}
            onClick={(v) => {
              setOneNexIndex(null as any)
              setOneNexIndex(t?.id ? (null as any) : 'retailPrice')
            }}
          >
            {displayValue}{' '}
          </span>
        ) : (
          ''
        )
      },
    },
    {
      title: '零售单价',
      align: 'right',
      width: '68px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'retailPrice',
      nextDataIndex: nexIndexCount,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: [
        {
          required: true,
          message: '请输入零售单价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        // onclick('edit', { prev, next })
        setNexIndexCount(null as any)
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const displayValue = t.retailPrice ? parseFloat(t.retailPrice).toFixed(5) : ''
        return t.retailPrice ? (
          <span
            title={displayValue}
            onClick={(v) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {displayValue}{' '}
          </span>
        ) : (
          ''
        )
      },
    },
    {
      title: '拆零单价',
      align: 'right',
      width: '68px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'splitPrice',
      nextDataIndex: nexIndexCount,
      placeholder: ' 0.00000',
      fixed: 'right',
      rules: [
        {
          required: true,
          message: '请输入拆零单价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        setNexIndexCount(null as any)
        setNexIndexCount(prev?.id ? (null as any) : 'count')
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: function Element(_, t) {
        const displayValue = t.splitPrice ? parseFloat(t.splitPrice).toFixed(5) : ''
        return t.splitTag?.toString() == '1' ? (
          <span
            title={displayValue}
            onClick={(v: any) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {t.splitPrice ? parseFloat(t.splitPrice).toFixed(5) : ''}
          </span>
        ) : t.splitTag?.toString() == '0' ? (
          <span
            title='0.00000'
            onClick={(v: any) => {
              setNexIndexCount(null as any)
              setNexIndexCount(t?.id ? (null as any) : 'count')
            }}
          >
            {t.splitPrice ? parseFloat('0').toFixed(5) : '0.00000'}
          </span>
        ) : (
          <span title={t.splitPrice ? String(t.splitPrice) : ''}>{t.splitPrice ? t.splitPrice : ''}</span>
        )
      },
    },
    {
      title: '数量',
      align: 'right',
      width: '60px',
      ellipsis: true,
      fixed: 'right',
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'count',
      placeholder: ' 1.00',
      rules: [
        {
          required: true,
          message: '请输入数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '小计',
      align: 'right',
      width: '80px',
      ellipsis: true,
      fixed: 'right',
      dataIndex: 'totalPrice',
      render: (_, t) => {
        return storehouseTag > 0 && !KFGZZCKLRSJData ? '***' : t.totalPrice ? parseFloat(t.totalPrice).toFixed(2) : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      fixed: 'right',
      width: '150px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div className={styles.bradeContent}>
            {t?.tenantMaterialsCatalogId && (
                <Button
                    type={t.tenantInventoryLedgerId ? 'ghost' : 'primary'}
                    disabled={storehouseTag > 0 ? true : false}
                    size='middle'
                    onClick={(e) => {
                        const liveBatchNo = getLiveBatchNo(e)
                        onclick('save', {
                            ...t,
                            invoiceNb: getLiveInvoiceNb(e) || t.invoiceNb,
                            batchNo: liveBatchNo !== undefined ? liveBatchNo : t.batchNo,
                        })
                    }}
                >
                    保存
                </Button>
            )}
            {(t?.billingCategory == '01' ||
              t?.billingCategory == '02' ||
              t?.billingCategory == '17') &&
              t.tenantInventoryLedgerId &&
              t?.name ? (
              <Badge
                count={t?.traceCodeCount < 0 ? 0 : t?.traceCodeCount}
                showZero={t?.traceCodeCount > -1}
              >
                {ybUploadFlag > 0 ? (
                  <Button
                    size='middle'
                    type='primary'
                    onClick={() => {
                      onclick('code', t)
                    }}
                    style={{
                      marginLeft: '10px',
                      background: '#F5F5F5',
                      color: '#b8b8b8',
                      borderColor: '#d9d9d9',
                      textShadow: 'none',
                    }}
                  >
                    追溯码
                  </Button>
                ) : (
                  <Button
                    size='middle'
                    type='primary'
                    onClick={() => {
                      onclick('code', t)
                    }}
                    style={{ marginLeft: '10px' }}
                  >
                    追溯码
                  </Button>
                )}
              </Badge>
            ) : (
              <></>
            )}
          </div>
        )
      },
    },
  ]
  return   invoiceEntryEnabled !== false ? columns : columns?.filter((v: any) => v?.dataIndex != 'invoiceNb')
}

export const PurchaseDeliveryColumns = (
  //购入退库
  storehouseId: string,
  storehouseTag: number,
  onclick: (text: string, t?: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '75px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      dataIndex: 'name',
      align: 'center',
      key: 'name',
      width: '200px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      storehouseId: storehouseId,
      nextDataIndex: 'count',
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const newdata2 = {
          ...newdata,
          totalPrice: 0,
        }
        const tenantInventoryLedgerId = newdata2.id
        const next = {
          ...newdata2,
          invCount: newdata2.count,
          tenantInventoryLedgerId,
          splitCount: 0,
          count: undefined,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      dataIndex: 'productInfo',
      align: 'center',
      width: '440px',
      ellipsis: true,
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '160px',
      ellipsis: true,
    },
    {
      title: '医保国码',
      dataIndex: 'hilistCode',
      align: 'center',
      width: '196px',
      ellipsis: true,
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
      width: '80px',
      ellipsis: true,
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      ellipsis: true,
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '实际数量',
      dataIndex: 'invCount',
      align: 'center',
      width: '90px',
      ellipsis: true,
      render: (_, t) => {
        return storehouseTag > 0 ? t.invCount + t.count : t.invCount
      },
    },
    {
      title: '退库金额',
      dataIndex: 'totalPrice',
      align: 'right',
      width: '90px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice * t.count
          ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
            2
          )
          : ''
      },
    },
    {
      title: '退库单价',
      dataIndex: 'unitPrice',
      align: 'right',
      width: '90px',
      ellipsis: true,
      // editable: storehouseTag > 0 ? false : true,
      // rules: [
      //   {
      //     required: true,
      //     message: '请输退库单价',
      //   },
      //   {
      //     pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
      //     message: '请输入正确的格式，最多保留小数点后5位',
      //   },
      // ],
      // onSave: (prev, next) => {
      //   onclick(prev.id ? 'submit' : 'edit', { prev, next })
      // },
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '退库数量',
      dataIndex: 'count',
      width: '90px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入退库数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '80px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Button
              ghost
              type={'primary'}
              disabled={storehouseTag > 0 ? true : false}
              size='small'
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          )
        )
      },
    },
  ]
}

export const TransferOutColumns = (
  //调拨出库
  storehouseId: string,
  storehouseTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '64px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      width: '210px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        const next = {
          ...newdata,
          invCount: newdata.count,
          tenantInventoryLedgerId,
          count: undefined,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
      width: '430px',
      ellipsis: true,
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '90px',
      ellipsis: true,
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
      width: '90px',
      ellipsis: true,
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      ellipsis: true,
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '库存数量',
      dataIndex: 'invCount',
      width: '100px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return storehouseTag > 0 ? t.invCount + t.count : t.invCount
      },
    },
    {
      title: '进价',
      dataIndex: 'unitPrice',
      width: '100px',
      ellipsis: true,
      align: 'right',
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '售价',
      dataIndex: 'retailPrice',
      nextDataIndex: 'count',
      align: 'right',
      width: '100px',
      ellipsis: true,
      editable: false,
      // editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入售价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: (_, t) => {
        return t.retailPrice
          ? parseFloat(t.retailPrice).toFixed(5)
          : t?.name
            ? '0.00000'
            : ''
      },
    },
    {
      title: '调拨出库数量',
      dataIndex: 'count',
      align: 'center',
      width: '130px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入调拨出库数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '调拨出库总金额(进价)',
      dataIndex: 'totalPrice',
      align: 'right',
      width: '180px',
      ellipsis: true,
      render: (_, t) => {
        return t.count
          ? parseFloat(
            ((t.count * t.unitPrice) as unknown) as string
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '调拨出库总金额(售价)',
      dataIndex: 'totalPrice',
      align: 'right',
      width: '180px',
      ellipsis: true,
      render: (_, t) => {
        return t.count
          ? parseFloat(
            ((t.count * t.retailPrice) as unknown) as string
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '80px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Button
              ghost
              type={'primary'}
              disabled={storehouseTag > 0 ? true : false}
              size='small'
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          )
        )
      },
    },
  ]
}

export const TransferInColumns = (
  //调拨入库
  storehouseTag: number
): EditableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      // 物资名称/规格/生产厂家/剂型）
      title: '药品名称',
      dataIndex: 'name',
      align: 'center',
      width: '14rem',
      ellipsis: true,
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      width: '10rem',
      ellipsis: true,
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '6rem',
      ellipsis: true,
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '进价',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
     {
      title: '售价',
      align: 'right',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice ? parseFloat(t.retailPrice).toFixed(5) : ''
      },
    },
    {
      title: '调拨入库数量',
      dataIndex: 'count',
      align: 'center',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '调拨入库总金额（进价）',
      align: 'right',
      width: '10rem',
      ellipsis: true,
      render: (_, t) => {
        return t.totalPrice ? parseFloat(t.totalPrice).toFixed(2) : ''
      },
    },
    {
      title: '调拨入库总金额（售价）',
      align: 'right',
      width: '10rem',
      ellipsis: true,
       render: (_, t) => {
        return t.count
          ? parseFloat(
            ((t.count * t.retailPrice) as unknown) as string
          ).toFixed(2)
          : ''
      },
    },
  ]
}

export const DebitOutColumns = (
  //借记出库
  storehouseId: string,
  storehouseTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号 ',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      width: '190px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        const next = {
          ...newdata,
          invCount: newdata.count,
          tenantInventoryLedgerId,
          count: null,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      align: 'center',
      width: '350px',
      ellipsis: true,
      dataIndex: 'productInfo',
    },
    {
      title: '产地',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'origin',
    },
    {
      title: '批号',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'batchNo',
    },
    {
      title: '有效期',
      align: 'center',
      width: '100px',
      ellipsis: true,
      dataIndex: 'deadline',
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '库存数量',
      dataIndex: 'invCount',
      width: '90px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        return storehouseTag > 0 ? t.invCount + t.count : t.invCount
      },
    },
    {
      title: '库存进价',
      align: 'right',
      width: '90px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '库存售价',
      align: 'right',
      dataIndex: 'retailPrice',
      nextDataIndex: 'count',
      width: '90px',
      ellipsis: true,
      editable: false,
      // editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入库存售价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: (_, t) => {
        return t.retailPrice
          ? parseFloat(t.retailPrice).toFixed(2)
          : t?.name
            ? '0.00'
            : ''
      },
    },
    {
      title: '借记出库数量',
      dataIndex: 'count',
      width: '120px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入借记出库数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '借记出库金额(进价)',
      align: 'right',
      width: '160px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice * t.count > 0
          ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
            2
          )
          : ''
      },
    },
    {
      title: '借记出库金额(售价)',
      align: 'right',
      width: '160px',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice * t.count > 0
          ? parseFloat(
            ((t.retailPrice * t.count) as unknown) as string
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Button
              ghost
              type={'primary'}
              disabled={storehouseTag > 0 ? true : false}
              size='small'
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          )
        )
      },
    },
  ]
}

export const DebitInColumns = (
  //借记还库
  storehouseTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      width: '180px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'batchNo',
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.Material,
      onSelectMaterial: (prev, newdata) => {
        const tenantMaterialsCatalogId = newdata.id
        const unitPrice = Number(newdata.stockPrice) === -1 ? undefined : newdata.stockPrice
        const next = {
          ...newdata,
          invCount: newdata.count,
          unitPrice,
          tenantMaterialsCatalogId,
          productDate: moment().format(DateTimeFormatSimple),
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      align: 'center',
      width: '320px',
      ellipsis: true,
      dataIndex: 'productInfo',
    },
    {
      title: '产地',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'origin',
    },
    {
      title: '批号',
      align: 'center',
      width: '80px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      dataIndex: 'batchNo',
      nextDataIndex: 'productDate',
      rules: [
        {
          required: true,
          message: '请输入批号',
        },
        {
          pattern: new RegExp(/^\S.*\S$/),
          message: '请按规范输入',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      width: '100px',
      ellipsis: true,
      nextDataIndex: 'deadline',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        { required: true, message: '请输入生产日期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (productDate) => {
        return productDate && productDate !== 'undefined'
          ? moment(productDate).format(DateTimeFormatSimple)
          : ''
      },
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      width: '100px',
      ellipsis: true,
      nextDataIndex: 'unitPrice',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        { required: true, message: '请输入有效期!' },
        {
          validator: (rule, value, callBack) => {
            if (
              moment(value, 'YYYYMMDD', true).isValid() ||
              moment(value, 'YYYY/MM/DD', true).isValid() ||
              moment(value, 'YYYY-MM-DD', true).isValid() ||
              value?.length == 4
            ) {
              callBack()
            } else {
              callBack('请先输入合法日期,时间格式为YYYYMMDD')
            }
          },
        },
      ],
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    // {
    //   title: "生产日期",
    //   align: "center",
    //   editable: storehouseTag > 0 ? false : true,
    //   dataIndex: "productDate",
    //   render: (productDate) => {
    //     return productDate && productDate !== "undefined"
    //       ? moment(productDate).format(DateTimeFormatSimple)
    //       : "";
    //   },
    //   onSave: (prev, next) => {
    //     onclick(prev.id ? "submit" : "edit", { prev, next });
    //   },
    // },
    {
      title: '库存进价',
      dataIndex: 'unitPrice',
      nextDataIndex: 'retailPrice',
      align: 'right',
      width: '90px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入库存进价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '库存售价',
      dataIndex: 'retailPrice',
      nextDataIndex: 'count',
      align: 'right',
      width: '90px',
      ellipsis: true,
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入库存售价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
    },
    {
      title: '借记还库数量',
      dataIndex: 'count',
      width: '120px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入借记还库数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '借记还库金额(进价)',
      align: 'right',
      width: '160px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice * t.count > 0
          ? parseFloat(((t.unitPrice * t.count) as unknown) as string).toFixed(
            2
          )
          : ''
      },
    },
    {
      title: '借记还库金额(售价)',
      align: 'right',
      width: '160px',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice * t.count > 0
          ? parseFloat(
            ((t.retailPrice * t.count) as unknown) as string
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Button
              ghost
              type={'primary'}
              disabled={storehouseTag > 0 ? true : false}
              size='small'
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          )
        )
      },
    },
  ]
}

// 领用出库
export const CollectColumns = (
  storehouseId: string,
  storehouseTag: number,
  categoryTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  const tenantCategory = useSelector(selectTenantCategory)
  const columns: EditableColumnType<any>[] = [
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      width: '200px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'count',
      storehouseId: storehouseId,
      categoryTag: categoryTag,
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        const next = {
          ...newdata,
          invCount: newdata.count,
          count: undefined,
          splitCount: undefined,
          tenantInventoryLedgerId,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      align: 'center',
      width: '320px',
      ellipsis: true,
      dataIndex: 'productInfo',
    },
    {
      title: '产地',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'origin',
    },
    {
      title: '批号',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'batchNo',
    },
    {
      title: '有效期',
      align: 'center',
      width: '100px',
      ellipsis: true,
      dataIndex: 'deadline',
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '库存数量',
      dataIndex: 'invCount',
      align: 'center',
      width: '90px',
      ellipsis: true,
      render: (_, t) => {
        return storehouseTag > 0 ? t.realCount + t.count : t.invCount
      },
    },
    {
      title: '库存进价',
      dataIndex: 'unitPrice',
      align: 'right',
      width: '80px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '库存售价',
      dataIndex: 'retailPrice',
      nextDataIndex: 'count',
      width: '80px',
      ellipsis: true,
      align: 'right',
      editable: false,
      // editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入库存售价',
        },
        {
          pattern: new RegExp(/^(([1-9]\d*)|(0{1}))(\.\d{0,5})?$/),
          message: '请输入正确的格式，最多保留小数点后5位',
        },
      ],
      onSave: (prev, next) => {
        onclick(prev.id ? 'submit' : 'edit', { prev, next })
      },
      render: (_, t) => {
        return t.retailPrice
          ? parseFloat(t.retailPrice).toFixed(2)
          : t?.name
            ? '0.00'
            : ''
      },
    },
    // 整存数量
    {
      title: '领用出库数量',
      dataIndex: 'count',
      width: '4rem',
      className: 'noRightBorder',
      // nextDataIndex: 'splitCount',
      ellipsis: true,
      align: 'center',
      colSpan: 4,
      editable: storehouseTag > 0 ? false : true,
      rules: [
        {
          required: true,
          message: '请输入领用整存数量',
        },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        if (prev.splitTag == 1) {
          onclick(prev.id ? 'submit' : 'edit', { prev, next, tempName })
        } else {
          onclick('submit', { prev, next, tempName })
        }
      },
    },
    // 整存单位 不可修改
    {
      dataIndex: 'accountUnit',
      align: 'center',
      width: '2.5rem',
      colSpan: 0,
    },
    // 拆零售价 （拆零时可以修改，不拆零时不可修改 暂时做不到 可以给出提示）
    {
      dataIndex: 'splitCount',
      align: 'center',
      width: '4rem',
      colSpan: 0,
      className: 'noRightBorder',
      editable: storehouseTag > 0 ? false : true,
      rules: [
        // {
        //   required: true,
        //   message: '请输入领用拆零数量',
        // },
        {
          pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,2})?$/),
          message: '请输入数字，支持小数点后两位',
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        if (prev.splitTag == 1) {
          onclick('submit', { prev, next, tempName })
        } else {
          onclick('noSplit', {})
        }
      },
    },
    // 拆零单位 不可修改
    {
      dataIndex: 'splitUnit',
      align: 'center',
      width: '2.5rem',
      colSpan: 0,
    },
    {
      title: '领用出库金额(进价)',
      align: 'right',
      width: '150px',
      ellipsis: true,
      render: (_, t) => {
        return t.unitPrice * (t.count || 0) +
          (t.unitPrice / t?.splitScale) * (t?.splitTag == 1 ? t?.splitCount : 0)
          ? parseFloat(
            (t.unitPrice * (t.count || 0) +
              (t.unitPrice / t?.splitScale) *
              (t?.splitTag == 1 ? t?.splitCount : 0)) as any
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '领用出库金额(售价)',
      align: 'right',
      width: '150px',
      dataIndex: 'retailPriceCount',
      ellipsis: true,
      render: (_, t) => {
        return t.retailPrice * (t.count || 0) +
          t.splitPrice * (t?.splitTag == 1 ? t?.splitCount : 0)
          ? parseFloat(
            (t.retailPrice * (t.count || 0) +
              t.splitPrice * (t?.splitTag == 1 ? t?.splitCount : 0)) as any
          ).toFixed(2)
          : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          t?.tenantMaterialsCatalogId && (
            <Button
              ghost
              type={'primary'}
              disabled={storehouseTag > 0 ? true : false}
              size='small'
              onClick={() => {
                onclick('save', t)
              }}
            >
              保存
            </Button>
          )
        )
      },
    },
  ]
  return tenantCategory == 17
    ? columns?.filter(v => v.dataIndex != 'retailPrice' && v.dataIndex != 'retailPriceCount')
    : columns
}

export const InventoryCloumn = (
  storehouseTag: number,
  onclick: (text: string, t: any) => void
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      align: 'center',
      dataIndex: 'name',
      width: '15%',
      autoFocus: (r) => !r.id && !r.name,
      nextDataIndex: 'realSplitCount',
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.Inventory,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        const next = {
          ...newdata,
          invCount: newdata.count,
          tenantInventoryLedgerId,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      align: 'center',
      dataIndex: 'productInfo',
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
    },
    {
      title: '拆零比例',
      align: 'center',
      dataIndex: 'splitScale',
    },
    {
      title: '拆零数',
      align: 'center',
      dataIndex: 'splitCount',
    },
    {
      title: '实际拆零数',
      align: 'center',
      dataIndex: 'realSplitCount',
      nextDataIndex: 'realCount',
      editable: storehouseTag > 0 ? false : true,
      onSave: (prev, next) => {
        onclick('edit', { prev, next })
      },
    },
    {
      title: '单价',
      className: 'notshow',
      dataIndex: 'unitPrice',
      align: 'right',
      render: (_, t) => {
        return t.unitPrice ? parseFloat(t.unitPrice).toFixed(5) : ''
      },
    },
    {
      title: '拆零单价',
      className: 'notshow',
      dataIndex: 'splitPrice',
      align: 'right',
      render: (_, t) => {
        return t.splitPrice ? parseFloat(t.splitPrice).toFixed(5) : ''
      },
    },
    {
      title: '账簿数',
      align: 'center',
      dataIndex: 'count',
    },
    {
      title: '实际数',
      align: 'center',
      dataIndex: 'realCount',
      editable: storehouseTag > 0 ? false : true,
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '盘盈盘亏数',
      align: 'center',
      render: (_, t) => {
        return isNaN(t.realCount - t.count) ? '' : t.realCount - t.count
      },
    },
    {
      title: '盘盈盘亏数(拆零)',
      align: 'center',
      render: (_, t) => {
        return isNaN(t.realSplitCount - t.splitCount)
          ? ''
          : t.realSplitCount - t.splitCount
      },
    },
    {
      title: '变动金额(进价)',
      align: 'right',
      dataIndex: 'trightice',
      render: (_, t) => {
        return isNaN(
          (t.realSplitCount - t.splitCount) * t.splitPrice +
          (t.realCount - t.count) * t.unitPrice
        )
          ? ''
          : (t.realSplitCount - t.splitCount) * t.splitPrice +
          (t.realCount - t.count) * t.unitPrice
      },
    },
  ]
}

// 报损
export const BaosunColumns = (
  storehouseId: string,
  storehouseTag: number,
  onclick: (text: string, t: any) => void,
  category?: any,
  KFGZZCKLRSJData?: any
): EditableColumnType<any>[] => {
  return [
    {
      title: '操作',
      align: 'center',
      width: '70px',
      ellipsis: true,
      render: function Element(_: any, t: { id: string }) {
        return (
          <div>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('add', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              ＋
            </Button>
            <Button
              type='link'
              disabled={storehouseTag > 0 ? true : false}
              onClick={() => {
                onclick('remove', t)
              }}
              style={{ fontSize: '24px', padding: 0 }}
            >
              －
            </Button>
          </div>
        )
      },
    },
    {
      title: '序号',
      align: 'center',
      width: '50px',
      ellipsis: true,
      render: (text: any, record: any, index: number) => `${index + 1}`,
    },
    {
      title: '名称',
      dataIndex: 'name',
      nextDataIndex: 'count',
      align: 'center',
      width: '230px',
      ellipsis: true,
      autoFocus: (r) => !r.id && !r.name,
      storehouseId: storehouseId,
      editable: storehouseTag > 0 ? false : true,
      inputType: 'material',
      completionType: ItemCompletionType.AllInventory,
      BScategory: category,
      onSelectMaterial: (prev, newdata) => {
        const tenantInventoryLedgerId = newdata.id
        const next = {
          ...newdata,
          invCount: newdata.count,
          //库存拆零数量单独保存，splitCount 作为拆零报损数量
          invSplitCount: newdata.splitCount,
          tenantInventoryLedgerId,
          count: undefined,
          //非拆零药品不允许填写拆零报损数量
          splitCount: Number(newdata.splitTag) === 1 ? undefined : 0,
          id: undefined,
        }
        onclick(prev.tenantInventoryLedgerId ? '' : 'edit', { prev, next })
      },
    },
    {
      title: '产品信息',
      dataIndex: 'productInfo',
      align: 'center',
      width: '550px',
      ellipsis: true,
    },
    {
      title: '产地',
      align: 'center',
      dataIndex: 'origin',
      key: 'origin',
      width: '80px',
      ellipsis: true,
    },
    {
      title: '批号',
      align: 'center',
      width: '80px',
      ellipsis: true,
      dataIndex: 'batchNo',
    },

    {
      title: '生产日期',
      align: 'center',
      width: '110px',
      ellipsis: true,
      dataIndex: 'productDate',
      render: (productDate) => {
        return productDate && productDate !== 'undefined'
          ? moment(productDate).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '有效期',
      align: 'center',
      width: '110px',
      ellipsis: true,
      dataIndex: 'deadline',
      render: (deadline) => {
        return deadline && deadline !== 'undefined'
          ? moment(deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '库存数量',
      dataIndex: 'realCount',
      width: '100px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        if (!t.id) return t.invCount
        if (storehouseTag > 0) {
          //报损登账后 realCount/count 可能为 0 或空，统一转数字，避免字符串相加或 undefined + 数字出现 NaN
          const total = Number(t.realCount || 0) + Number(t.count || 0)
          return Number.isNaN(total) ? '' : total.toFixed(2)
        }
        return t.realCount
      },
    },
    {
      title: '库存拆零数量',
      dataIndex: 'invSplitCount',
      width: '120px',
      ellipsis: true,
      align: 'center',
      render: (_, t) => {
        if (t.splitTag != 1) return '-'
        if (t.id) {
          return storehouseTag > 0
            ? Number(t.realSplitCount || 0) + Number(t.splitCount || 0)
            : t.realSplitCount
        }
        return t.invSplitCount !== undefined && t.invSplitCount !== null
          ? t.invSplitCount
          : ''
      },
    },
    {
      title: '报损数量',
      dataIndex: 'count',
      width: '100px',
      ellipsis: true,
      align: 'center',
      editable: storehouseTag > 0 ? false : true,
      saveOnBlur: false,
      onInputChange: (record, value) => {
        onclick('changeCount', { record, value })
      },
      rules: [
        {
          validator: (_, value, callback) => {
            if (
              !value ||
              /^(0|[1-9]\d*)(\.\d{1,2})?$/.test(String(value))
            ) {
              callback()
            } else {
              callback('请输入数字，支持小数点后两位')
            }
          },
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        onclick('submit', { prev, next, tempName })
      },
    },
    {
      title: '拆零报损数量',
      dataIndex: 'splitCount',
      width: '120px',
      ellipsis: true,
      align: 'center',
      //只有已选择药品且目录拆零标志 splitTag=1 时才允许填写拆零报损数量
      editable: (record: any) =>
        !(storehouseTag > 0) &&
        !!record.tenantMaterialsCatalogId &&
        Number(record.splitTag) === 1,
      saveOnBlur: false,
      onInputChange: (record, value) => {
        onclick('changeSplitCount', { record, value })
      },
      rules: (record: any) => [
        {
          validator: (_, value, callback) => {
            if (Number(record.splitTag) !== 1) {
              if (value) {
                callback('该药品未启用拆零，不能填写拆零报损数量')
              } else {
                callback()
              }
              return
            }
            if (
              !value ||
              /^(0|[1-9]\d*)(\.\d{1,3})?$/.test(String(value))
            ) {
              callback()
            } else {
              callback('请输入数字，支持小数点后三位')
            }
          },
        },
      ],
      onSave: (prev, next) => {
        const tempName = prev.name
        if (prev.splitTag == 1) {
          onclick('submit', { prev, next, tempName })
        } else {
          onclick('noSplit', {})
        }
      },
      render: (_, t) => {
        if (t.splitTag != 1) return '-'
        return t.splitCount !== undefined && t.splitCount !== null
          ? t.splitCount
          : ''
      },
    },
    // {
    //   title: '进价',
    //   dataIndex: 'unitPrice',
    //   className: 'notshow',
    //   width: '120px',
    //   ellipsis: true,
    //   align: 'right',
    // },
    {
      title: '报损金额(进价)',
      align: 'right',
      width: '130px',
      ellipsis: true,
      render: (_, t) => {
        if (!KFGZZCKLRSJData) return '***'
        const unitPrice = Number(t.unitPrice || 0)
        const splitScale = Number(t.splitScale || 1)
        const count = Number(t.count || 0)
        const splitCount = t.splitTag == 1 ? Number(t.splitCount || 0) : 0
        const total =
          unitPrice * count +
          (splitScale > 0 ? (unitPrice / splitScale) * splitCount : 0)
        return total ? parseFloat(String(total)).toFixed(2) : ''
      },
    },
    {
      title: '操作',
      align: 'center',
      width: '90px',
      ellipsis: true,
      render: function Element(_, t) {
        return (
          <div className={styles.bradeContent}>
            {t?.tenantMaterialsCatalogId && (
              <Button
                ghost
                type={'primary'}
                disabled={storehouseTag > 0 ? true : false}
                size='middle'
                onClick={() => {
                  onclick('save', t)
                }}
              >
                保存
              </Button>
            )}
          </div>
        )
      },
    },
  ]
}

// 序号、物资信息（物资名称/有效期至/厂家/批准文号/规格/剂型）、批次号、拆零比例、拆零数、实际拆零数、账簿数、实际数、盘盈盘亏数、盘盈盘亏数(拆零)、变right)

// 验收单
export const AcceptanceModalColumns = (
  onclick: (t: any) => void,
  startIndex: number
): EditableColumnType<any>[] => {
  return [
    {
      title: '序号',
      align: 'center',
      width: '3rem',
      ellipsis: true,
      render: (_1, _2, index) => `${startIndex + index + 1}`,
    },
    {
      title: '产品信息',
      align: 'left',
      dataIndex: '',
      width: '16rem',
      ellipsis: true,
      key: '',
      render: function Element(_, record) {
        return (
          <Popover
            content={
              <>
                <div style={{ height: '55px' }}>
                  <p
                    className={styles.nameText}
                  >
                    {record.name}
                  </p>
                  <p
                    className={styles.productText}
                  >
                    {record.productInfo}
                  </p>
                </div>
              </>
            }
            placement='bottom'
          >
            <div style={{ height: '55px' }}>
              <p
                className={styles.nameText}
              >
                {record.name}
              </p>
              <p
                className={styles.productText}
              >
                {record.productInfo}
              </p>
            </div>
          </Popover>
        )
      },
    },
    {
      title: '供应商',
      align: 'center',
      dataIndex: 'tenantSupplierName',
      key: 'tenantSupplierName',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '批号',
      align: 'center',
      dataIndex: 'batchNo',
      key: 'batchNo',
      width: '5rem',
      ellipsis: true,
    },
    {
      title: '生产日期',
      align: 'center',
      dataIndex: 'productDate',
      key: 'productDate',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.productDate
          ? moment(t?.productDate).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '有效期',
      align: 'center',
      dataIndex: 'deadline',
      key: 'deadline',
      width: '6rem',
      ellipsis: true,
      render: (_, t) => {
        return t?.deadline
          ? moment(t?.deadline).format(DateTimeFormatSimple)
          : ''
      },
    },
    {
      title: '到货数量',
      align: 'center',
      dataIndex: 'count',
      key: 'count',
      width: '6rem',
      ellipsis: true,
    },
    {
      title: '验收合格数量',
      align: 'center',
      dataIndex: 'count',
      key: 'count',
      width: '7rem',
      ellipsis: true,
    },
    {
      title: '验收不合格数量',
      align: 'center',
      dataIndex: 'bhgCount',
      key: 'bhgCount',
      width: '8rem',
      ellipsis: true,
    },
    {
      title: '质量状况',
      align: 'center',
      dataIndex: 'qualityStatus',
      key: 'qualityStatus',
      editable: true,
      width: '7rem',
      ellipsis: true,
      onSave: (prev, next) => {
        onclick({ prev, next })
      },
    },
    {
      title: '验收结论',
      align: 'center',
      dataIndex: 'acceptanceConclusion',
      key: 'acceptanceConclusion',
      editable: true,
      width: '7rem',
      ellipsis: true,
      onSave: (prev, next) => {
        onclick({ prev, next })
      },
    },
    {
      title: '备注',
      align: 'center',
      dataIndex: 'remark',
      key: 'remark',
      width: '7rem',
      ellipsis: true,
      editable: true,
      onSave: (prev, next) => {
        onclick({ prev, next })
      },
    },
  ]
}
